export enum PermissionEnum {
  ALL = "ALL",
  CREATE_USERTYPE = "CREATE_USERTYPE",
  VIEW_USERTYPE = "VIEW_USERTYPE",
  UPDATE_USERTYPE = "UPDATE_USERTYPE",
  DELETE_USERTYPE = "DELETE_USERTYPE",
  ADD_ROLE = "ADD_ROLE",
  UPDATE_ROLE = "UPDATE_ROLE",
  VIEW_ROLE = "VIEW_ROLE",
  DELETE_ROLE = "DELETE_ROLE",
  ADD_PERMISSION = "ADD_PERMISSION",
  UPDATE_PERMISSION = "UPDATE_PERMISSION",
  DELETE_PERMISSION = "DELETE_PERMISSION",
  VIEW_PERMISSION = "VIEW_PERMISSION",
  ADD_TASK = "ADD_TASK",
  UPDATE_TASK = "UPDATE_TASK",
  DELETE_TASK = "DELETE_TASK",
  VIEW_TASK = "VIEW_TASK",
  ADD_USERROLE = "ADD_USERROLE",
  UPDATE_USERROLE = "UPDATE_USERROLE",
  DELETE_USERROLE = "DELETE_USERROLE",
  VIEW_USERROLE = "VIEW_USERROLE",
  ADD_ROLEPERMISSION = "ADD_ROLEPERMISSION",
  UPDATE_ROLEPERMISSION = "UPDATE_ROLEPERMISSION",
  DELETE_ROLEPERMISSION = "DELETE_ROLEPERMISSION",
  VIEW_ROLEPERMISSION = "VIEW_ROLEPERMISSION",
  ADD_MODULE = "ADD_MODULE",
  UPDATE_MODULE = "UPDATE_MODULE",
  DELETE_MODULE = "DELETE_MODULE",
  VIEW_MODULE = "VIEW_MODULE",
  ADD_APPLICATION = "ADD_APPLICATION",
  UPDATE_APPLICATION = "UPDATE_APPLICATION",
  DELETE_APPLICATION = "DELETE_APPLICATION",
  VIEW_APPLICATION = "VIEW_APPLICATION",
  ADD_MENU = "ADD_MENU",
  UPDATE_MENU = "UPDATE_MENU",
  DELETE_MENU = "DELETE_MENU",
  VIEW_MENU = "VIEW_MENU",
  ADD_ROLETASK = "ADD_ROLETASK",
  UPDATE_ROLETASK = "UPDATE_ROLETASK",
  DELETE_ROLETASK = "DELETE_ROLETASK",
  VIEW_ROLETASK = "VIEW_ROLETASK",
  ADD_MENUPERMISSION = "ADD_MENUPERMISSION",
  UPDATE_MENUPERMISSION = "UPDATE_MENUPERMISSION",
  DELETE_MENUPERMISSION = "DELETE_MENUPERMISSION",
  VIEW_MENUPERMISSION = "VIEW_MENUPERMISSION",
  CHANGE_PASSWORD = "CHANGE_PASSWORD",
  ADD_NEWUSER = "ADD_NEWUSER",
  CHANGE_STATUS_NEWUSER = "CHANGE_STATUS_NEWUSER",
  VIEW_NEWUSER = "VIEW_NEWUSER",
  VIEW_USERTASK = "VIEW_USERTASK",
  VIEW_USER_REPORT = "VIEW_USER_REPORT",
  VIEW_TRANSACTION_REPORT = "VIEW_TRANSACTION_REPORT",
  VIEW_DASHBOARD_SUMMARY_REPORT = "VIEW_DASHBOARD_SUMMARY_REPORT",
  VIEW_FAMILY_DETAIL_REPORT = "VIEW_FAMILY_DETAIL_REPORT",
  EXCEL_EXPORT_USERLIST = "EXCEL_EXPORT_USERLIST",
}

